// Catálogo de Ejercicios (Años) para el filtro de Reporte de Refacciones.
// Ya NO es un arreglo fijo: se genera en base al año actual, 5 años atrás y
// 5 años adelante (11 años en total), para que el catálogo siempre incluya
// el año en curso sin necesidad de actualizar este archivo cada año.
// Mismo shape que antes ({ id, display }), así que no requiere cambios en
// quien lo consume (FiltroReporteRefacciones.js, AnioSelect.js).
// NOTA: sigue siendo un catálogo local mientras se conecta el endpoint real
// (ver TODO en AnioSelect.js).
const ANIOS_ATRAS = 6;
const ANIOS_ADELANTE = 0;

const generarAnioArray = () => {
    const anioActual = new Date().getFullYear();
    const anios = [];
    for (let anio = anioActual - ANIOS_ATRAS; anio <= anioActual + ANIOS_ADELANTE; anio++) {
        anios.push({ id: anio, display: String(anio) });
    }
    return anios;
};

export const AnioArray = generarAnioArray();
